import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves the spot price for a commodity from the API gateway (Redis-backed cache server-side).
 *
 * @param {object} _this - Context object containing necessary data.
 * @param {string} fieldName - Field name to store the retrieved spot price.
 * @param {string} fieldUpdatedAtName - Field name for storing the timestamp of the update.
 * @param {string} fieldShowLoadingName - Field name to indicate if loading should be displayed.
 * @param {string} [strip=null] - Field determining whether the request is for the whole strip (for commodities only).
 * @param {boolean} [isContract=false] - Determines if the request is for a contract-based price.
 * @returns {Promise<object>} - A promise resolving to the spot price data.
 */
export function getSpotCommodity(
  _this,
  fieldName,
  fieldUpdatedAtName,
  fieldShowLoadingName,
  strip = null,
  isContract = false,
) {
  _this[fieldShowLoadingName] = !isContract;
  _this[fieldName] = 0;
  if (_this.$route.path === "/optimizer" || isContract) {
    // contract left as-is (undefined case handled by caller)
  } else if (_this.contract === undefined) {
    _this.contract = 1;
  }
  const commodityNumber = _this.commodityNumber
    ? _this.commodityNumber
    : _this.commoditySpecs[_this[_this.fieldA][1]].pk_idcommodity;
  return gatewayService.commodities.intradayHistory({
    format: "json",
    last: 1,
    commodity: commodityNumber,
    contract: strip == null ? _this.contract : 0,
  });
}
